const messages = {
  box: {
    title: "Visibilité en ligne",
  },
  title: "Visibilité en ligne",
  description:
    "Augmentez et contrôlez votre visibilité numérique au niveau du POS avec UBERALL",
  category_title: "uberall - améliorer la visibilité digitale",
  category_description:
    "Utilisez maintenant vos points de récompense pour faire passer votre marketing numérique au niveau supérieur. Grâce à la plateforme uberall, Bridgestone aide ses partenaires commerciaux à optimiser leur présence en ligne afin de générer plus de visiteurs. Et ce, sur plus de 100 plates-formes telles que Google, Facebook, Bing ou Trustpilot.",
  content: "Profitez dès à présent des avantages d'uberall :",
  point1: "Optimisation de la visibilité en ligne",
  point2: "Commande & contrôle pratiques des emplacements POS",
  point3:
    "Suivre la visibilité locale, les évaluations et le contenu des médias sociaux",
  footer:
    "Pour obtenir des informations détaillées et vous faire une première idée d'uberall, regardez la vidéo ci-dessous.",
  period: "Durée : 1 an",
  form: {
    title: "Ainsi, vous utilisez uberall pour votre entreprise :",
    point1: "Souscrire un abonnement annuel pour 480 points",
    point2: "Après vérification interne, vous recevrez une confirmation",
    point3: "pas de renouvellement automatique",
    pointDiscount: "points dans un {price} CHF de pour les suivants",
    howMuch: "Combien de points souhaitez-vous utiliser ?",
  },
  uberall: {
    title: "ABONNEMENT UBERALL",
  },
  haveQuestion: "Vous avez une question ?",
  contactUs: "N'hésitez pas à nous envoyer un e-mail à",
};

export default {
  messages,
};
